export default __webpack_public_path__ + "static/img/Onboarding_Panel_light.44da5afe.svg";